export default __webpack_public_path__ + "static/seat-dbdc65bfa3f5f16461f1307f4cee63a6.png";